import { api } from "./api";
import type { ClothingItem, ProductsResponse } from "../types/product";
import { FilterSetting } from "@/types/filter";

class ProductServiceApi {
  public async getProducts(page?: number, page_size?: number, filter?: FilterSetting) {
    const closetsFilters: Partial<FilterSetting> = {};

    if (filter?.closets) {
      closetsFilters.closets = filter?.closets;
      closetsFilters.by_main_closet = undefined;
    }

    if (filter?.by_main_closet) {
      closetsFilters.by_main_closet = filter?.by_main_closet;
      closetsFilters.closets = undefined;
    }

    const response = await api.get<ProductsResponse<ClothingItem[]>>("/core/product/", {
      params: {
        page: page || filter?.page,
        page_size: page_size || filter?.page_size,
        search: filter?.search,
        categories: filter?.selectedCategories,
        attributes: filter?.selectedAttributes,
        brands: filter?.selectedBrands,
        ordering: filter?.selectedSortBy,
        merchandising: filter?.selectedMerchandisings,
        favorite: filter?.favorite ? "True" : "", // TODO remove this when api is ready to handle
        tags: filter?.selectedTags || [],
        ...closetsFilters
      },
      paramsSerializer: {
        indexes: null
      }
    });

    return response.data;
  }

  public async getProductById(product_id: string) {
    const response = await api.get<ClothingItem>(`/core/product/${product_id}/`);
    return response.data;
  }
}

const ProductService = new ProductServiceApi();

export { ProductService };
